import React from "react";
import Header from "../../Pages/Header";
import NavBarManager from "../../PagesManager/NavBarManager";
import Navbar from "../../Pages/NavBar";
import { useLocation, useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const MainLayoutManager = ({ children }) => {




  // to read params url 
  const location = useLocation();
  // استخراج GUID باستخدام Regular Expression
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/")
  console.log(encryptedToken, "slkdslkdlksdl");
  var guid = encryptedToken[encryptedToken.length - 1] != null ? decryptToken(encryptedToken[encryptedToken.length - 1]) : null
  if (encryptedToken.includes("PrepareProgressReport") ) {
    guid = null
  }

  if (encryptedToken.includes("ReportStageContainerManager")) {
    guid = null
  }else if (encryptedToken.includes("ReportSummaryPage")) 
    {
    guid = null
    }

  return (
    <>
      <div>
        <Header guid={guid} location={guid ? "manager" : ""} />

        {

          guid ? <Navbar location="manager" /> : <NavBarManager />
        }


        <main>{children}</main>
      </div>
    </>
  );
};

export default MainLayoutManager;
